/**
 * Renders the fields changed by a revision as clickable chips under the
 * assistant message that made the change. Clicking a chip reveals the field in
 * the plan panel, which shows the old text struck through above the new — the
 * panel owns the diff detail, so the chat message stays compact.
 */
import { FieldDiff } from "../../../models/audit/collabFieldDiff";

export const RevisionDiff = ({
  diffs,
  onNavigate,
}: {
  diffs: FieldDiff[];
  /** Reveal the given field in the plan panel. */
  onNavigate?: (fieldKey: string) => void;
}) => {
  if (diffs.length === 0) return null;

  return (
    <div className="mt-2 rounded-md border border-stone-200 bg-white p-2">
      <div className="text-xs font-semibold text-stone-500">Changed fields</div>
      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {diffs.map((diff) => (
          <button
            key={diff.key}
            type="button"
            onClick={() => onNavigate?.(diff.navigateKey ?? diff.key)}
            title="Show this change in the plan"
            className="rounded-sm bg-stone-100 px-1.5 py-0.5 text-left text-[11px] text-stone-600 transition-colors hover:bg-stone-200 hover:text-stone-900"
          >
            {diff.label}
          </button>
        ))}
      </div>
    </div>
  );
};
